module.exports = __webpack_public_path__ + "img/tt.b8242706.png";